import { useContext, useEffect } from 'react';
import { StompContext } from './index';

export function useStomp() {
  const context = useContext(StompContext);
  return context;
}

export function useSubscription<T = unknown>(
  destination: string,
  handler: (_data: T) => void,
  deps: React.DependencyList = []
) {
  const { addSubscription, removeSubscription } = useStomp();

  useEffect(() => {
    if (destination) {
      addSubscription(destination, handler);
    }
    return () => {
      if (destination) {
        removeSubscription(destination, handler);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [destination, ...deps]);
}
